import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  authErrors: string;
  loginForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
    ]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
    ]),
  });

  constructor(private authService: AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
  }

  login() {
  this.spinnerService.show();
  this.authService.login(this.loginForm.value).then(
    async (user) => {
     await this.authService.getUserdetails(user.user);
     this.getRole().then(
       (userRole)=>{
         console.log("User Role extracted: "+ userRole);
        window.localStorage.setItem("userRole",userRole);

         switch (userRole) {
           case 'superAdmin':
              window.localStorage.setItem("superAdmin",'true');
            this.router.navigate( ['dashboard/overview'] ).then(
              () => {
                this.spinnerService.hide();
              }
            ).catch((error)=>{
              this.authService.logout();
              console.log("Error: ", error.message);
              
            });
            break;
          case 'admin': 
          window.localStorage.setItem("admin",'true');
          this.router.navigate( ['dashboard/overview'] ).then(
            () => {
              this.spinnerService.hide();
            }
          ).catch((error)=>{
            this.authService.logout();
            console.log("Error: ", error.message);
            
          });
          break;

          case 'bookingClerk': 
          window.localStorage.setItem("bookingClerk",'true');
          this.router.navigate( ['dashboard/booking/addNew'] ).then(
            () => {
              this.spinnerService.hide();
            }
          ).catch((error)=>{
            this.authService.logout();
            console.log("Error: ", error.message);
            
          });
          break;
         
          case 'manager': 
          window.localStorage.setItem("manager",'true');
          this.router.navigate( ['dashboard/overview'] ).then(
            () => {
              this.spinnerService.hide();
            }
          ).catch((error)=>{
            this.authService.logout();
            console.log("Error: ", error.message);
            
          });
          break;
          case 'courierClerk': 
          window.localStorage.setItem("courierClerk",'true');
          this.router.navigate( ['dashboard/courier'] ).then(
            () => {
              this.spinnerService.hide();
            }
          ).catch((error)=>{
            this.authService.logout();
            console.log("Error: ", error.message);
            
          });
          break;
         
           default:
             break;
         }
         
       }
     )
     
    }
  ).catch((error) => {
    if (error.message.includes(' or ')) {
      this.authErrors = error.message.split(' or ')[0];
      this.spinnerService.hide();
    } else if (error.message.includes('. ')) {
      this.authErrors = error.message.split('. ')[0];
      this.spinnerService.hide();
    } else {    this.authErrors = error.message; this.spinnerService.hide();   }
  });
  }
  async getRole(){
    var userRole =  '';
  await   this.authService.getCustomClaim(window.localStorage.getItem('uid')).then(
      (customClaim)=>{
        if(customClaim.claims.superAdmin){
          userRole = 'superAdmin';
        }else if(customClaim.claims.admin) {
          userRole = 'admin';
        } else if(customClaim.claims.manager){
          userRole = 'manager'
        }
        else if(customClaim.claims.bookingClerk){
          userRole = 'bookingClerk'
        }else if(customClaim.claims.courierClerk){
          userRole = 'courierClerk'
        }
      }
    )
    return userRole;
  }
}
